import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./sourceDataTable.html";
import { sortByDate, formatDate, formatLocaleDate, getDateLocaleFormat, getDelimiterFromLocaleDateFormat } from '../utils/DateTimeUtils';
import { MODIFIED_ON, NONE_OPTION } from '../utils/appConstants';
const columns = [{
  label: 'Name',
  fieldName: 'name',
  sortable: true,
  initialWidth: 205
}, {
  label: 'Developer Name',
  fieldName: 'developerName',
  sortable: true,
  initialWidth: 205
}, {
  label: 'Type',
  fieldName: 'componentName',
  sortable: true
}, {
  label: 'Modified By',
  fieldName: 'modifiedBy',
  sortable: true,
  initialWidth: 120
}, {
  label: 'Modified On',
  fieldName: 'modifiedOn',
  sortable: true,
  type: 'helpTextDisplay',
  typeAttributes: {
    label: {
      fieldName: 'modifiedOn'
    },
    tooltip: {
      fieldName: 'modifiedBy'
    }
  }
}, {
  label: 'Dependencies',
  fieldName: 'dependencyCellData',
  type: "formattedUrl",
  sortable: true,
  initialWidth: 140,
  typeAttributes: {
    label: {
      fieldName: 'dependencyCellData'
    },
    data: {
      fieldName: 'dependencies'
    },
    name: {
      fieldName: 'name'
    },
    developerName: {
      fieldName: 'developerName'
    }
  }
}];
class SourceDataTable extends LightningElement {
  constructor() {
    super();
    this.data = [];
    this.columns = columns;
    this.record = {};
    this.selectedsourceorgrows = void 0;
    this.selectedsourcedata = void 0;
    this.istargetorgloggedin = void 0;
    this.issearchenabled = void 0;
    this.targettreegriddata = void 0;
    this.preselectedrowsids = void 0;
    this.searchvalue = void 0;
    this.originalconfigurations = void 0;
    this.gridLoadingState = false;
    this.isFilterModalOpen = false;
    this.originalSelectedRows = [];
    this.selectedRows = [];
    this.searchSelectedRows = [];
    this.previousSelectedRows = [];
    this.isSourceRowSelected = false;
    this.defaultSortDirection = 'asc';
    this.sortDirection = 'asc';
    this.sortedBy = void 0;
    this.searchConfigName = '';
    this.searchDeveloperName = '';
    this.searchCompType = '';
    this.searchModifiedBy = '';
    this.searchTags = '';
    this.searchSubType = '';
    this.searchFromDate = '';
    this.searchToDate = '';
    this.isexportbtndisabled = void 0;
    this.selectedRowsIds = [];
    this.depSelectedRowsData = [];
    this.uniqueCompType = [];
    this.uniqueModifiedBy = [];
    this.uniqueTags = [];
    this.selectedOptionTypeValues = [];
    this.selectedModifiedValues = [];
    this.selectedTagsValues = [];
    this.searchValueExists = false;
    this.searchResultRows = [];
    this.filteredConfigs = [];
    this.getSelNames = selValues => {
      let selNames = [];
      if (selValues) {
        for (let index = 0; index < selValues.length; index++) {
          const {
            name
          } = selValues[index];
          selNames.push(name);
        }
      }
      return selNames;
    };
    this.enableDisableFilterTextClearButton = () => {
      if (this.template.querySelector('my-filter-modal')) {
        if (this.searchConfigName) {
          this.template.querySelector('my-filter-modal').enableDisableClearButton('configurationNameButton', 'block');
        }
        if (this.searchDeveloperName) {
          this.template.querySelector('my-filter-modal').enableDisableClearButton('developerNameButton', 'block');
        }
        if (this.searchCompType) {
          this.template.querySelector('my-filter-modal').enableDisableClearButton('compTypeButton', 'block');
        }
      }
    };
    this.handleExportConfigurations = () => {
      let selectedRowsData = this.selectedsourcedata;
      const exportConfigurationRows = new CustomEvent('exportconfigurations', {
        detail: selectedRowsData,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(exportConfigurationRows);
    };
    this.closeExportConfModal = () => {
      const closeExportConfModal = new CustomEvent('closeexportconfmodal', {
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(closeExportConfModal);
    };
    this.selectedDependenciesRows = event => {
      const depSelectedRows = event.detail;
      let sourceSelRows = [];
      if (this.selectedsourceorgrows) {
        sourceSelRows = [...this.selectedsourceorgrows, ...depSelectedRows];
      } else {
        sourceSelRows = depSelectedRows;
      }
      if (sourceSelRows !== undefined && sourceSelRows !== null) {
        for (let index = 0; index < sourceSelRows.length; index++) {
          const {
            id
          } = sourceSelRows[index];
          this.selectedRowsIds.push(id);
        }
        this.depSelectedRowsData = [...this.depSelectedRowsData, ...depSelectedRows];
      }
      this.preselectedrowsids = [...new Set(this.selectedRowsIds)];
      if (this.selectedsourceorgrows) {
        this.selectedsourceorgrows = [...this.selectedsourceorgrows, ...this.depSelectedRowsData];
      } else {
        this.selectedsourceorgrows = this.depSelectedRowsData;
      }
      if (this.selectedsourcedata) {
        this.selectedsourcedata = [...this.selectedsourcedata, ...this.depSelectedRowsData];
      } else {
        this.selectedsourcedata = this.depSelectedRowsData;
      }
      const formattedRows = this.formattedSelectedSourceOrgRows(this.selectedsourceorgrows);
      const selectedEvent = new CustomEvent('selectedsourcegridrows', {
        detail: [...formattedRows]
      });
      this.dispatchEvent(selectedEvent);
    };
    this.formattedSelectedSourceOrgRows = details => {
      const selectedSourceRowList = [];
      let uniqueRows = [];
      if (details) {
        for (let index = 0; index < details.length; index++) {
          const {
            componentName,
            componentType,
            configType,
            createdBy,
            createdOn,
            dependencies,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          } = details[index];
          const formattedList = {
            componentName,
            componentType,
            configType,
            createdBy,
            createdOn,
            dependencies,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          };
          selectedSourceRowList.push(formattedList);
        }
      }
      if (selectedSourceRowList) {
        const ids = selectedSourceRowList.map(o => o.id);
        uniqueRows = selectedSourceRowList.filter(({
          id
        }, index) => !ids.includes(id, index + 1));
      }
      return uniqueRows;
    };
    this.selectedDepRowIds = event => {
      const selectedRowsIds = [];
      const dependencyModalRowIds = [];
      const selRows = event.detail;
      const dataTableSelRows = this.selectedsourceorgrows;
      for (let index = 0; index < selRows.length; index++) {
        if (selRows[index] !== null) {
          const {
            id
          } = selRows[index];
          dependencyModalRowIds.push(id);
          if (this.selectedsourceorgrows) {
            for (let index = 0; index < dataTableSelRows.length; index++) {
              const {
                id
              } = dataTableSelRows[index];
              if (dependencyModalRowIds.includes(id)) {
                selectedRowsIds.push(id);
              }
            }
          }
        }
      }
      const selectedRowsIdsEvent = new CustomEvent('selecteddependencyrowids', {
        detail: selectedRowsIds,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(selectedRowsIdsEvent);
    };
    this.updateSelectedDepRows = () => {
      this.selectedsourceorgrows = [];
      this.depSelectedRowsData = [];
      this.selectedsourcedata = [];
      this.selectedRowsIds = [];
      this.previousSelectedRows = [];
    };
    this.updateDepRowsAfterRemoveTargetRecord = targetTableData => {
      if (this.depSelectedRowsData) {
        this.depSelectedRowsData = targetTableData.filter(o1 => this.depSelectedRowsData.some(o2 => o1.id === o2.id));
      }
    };
    this.updatePreviousSelectedRows = sourceSelectedRows => {
      this.previousSelectedRows = [];
      this.searchSelectedRows = [];
      this.depSelectedRowsData = [];
      this.selectedRowsIds = [];
      this.selectedsourceorgrows = sourceSelectedRows.length > 0 ? sourceSelectedRows : [];
    };
    this.getSelectedName = event => {
      let selectedRows = event.detail.selectedRows;
      let searchSelRows = [];
      if (!this.issearchenabled) {
        if (selectedRows.length > 0) {
          this.isSourceRowSelected = true;
        } else {
          this.isSourceRowSelected = false;
          this.previousSelectedRows = [];
          this.searchSelectedRows = [];
          this.depSelectedRowsData = [];
          this.selectedRowsIds = [];
        }
        this.targettreegriddata = [];
        this.selectedsourceorgrows = selectedRows;
        this.selectedsourcedata = selectedRows;
        this.previousSelectedRows = [...this.selectedsourceorgrows];
        const selectedEvent = new CustomEvent('selectedsourcegridrows', {
          detail: selectedRows
        });
        this.dispatchEvent(selectedEvent);
      } else {
        this.getSearchSelectedRows(selectedRows);
        let targetData = this.targettreegriddata.length > 0 ? this.targettreegriddata : this.previousSelectedRows;
        this.isSourceRowSelected = true;
        const tempSearchSelectedRows = this.searchSelectedRows;
        let unSelectedRowsData = [...targetData];
        if (this.searchSelectedRows.length !== selectedRows.length) {
          this.removeSearchUnSelectedRows(selectedRows);
          let unSelectedRows = tempSearchSelectedRows.filter(o1 => !this.searchSelectedRows.some(o2 => o1.id === o2.id));
          if (unSelectedRows && unSelectedRows.length > 0) {
            const {
              id: unSelectedId
            } = unSelectedRows[0];
            let formattedUnSelectedData = this.formatTargetData(this.selectedsourcedata);
            unSelectedRowsData = formattedUnSelectedData.filter(item => item.id !== unSelectedId);
          }
        }
        if (this.searchSelectedRows && this.searchSelectedRows.length > 0) {
          searchSelRows = unSelectedRowsData.concat(this.searchSelectedRows);
        }
        if (searchSelRows.length > 0) {
          searchSelRows = this.removeDuplicateRows(searchSelRows);
        } else {
          searchSelRows = targetData;
          this.isSourceRowSelected = false;
        }
        if (this.searchSelectedRows !== undefined && this.searchSelectedRows.length === 0 && this.searchvalue !== null) {
          let filterData = searchSelRows.find(item => item.name.toLowerCase() === this.searchvalue);
          if (filterData !== undefined) {
            const {
              id
            } = filterData;
            filterData = searchSelRows.filter(item => item.id !== id);
            searchSelRows = filterData;
          }
        }
        if (selectedRows.length === 0 && this.searchvalue) {
          let formattedTargetData = this.formatTargetData(targetData);
          selectedRows = formattedTargetData.filter(item => item.name.toLowerCase().includes(this.searchvalue) || item.developerName.toLowerCase().includes(this.searchvalue));
          searchSelRows = formattedTargetData.filter(o1 => !selectedRows.some(o2 => o1.id === o2.id));
        }
        if (selectedRows.length === 0 && this.searchCompType != null && this.searchCompType.length > 0) {
          let formattedTargetData = this.formatTargetData(targetData);
          const tempConfigurations = formattedTargetData.filter(item => this.searchCompType.includes(item.componentName));
          searchSelRows = formattedTargetData.filter(o1 => !tempConfigurations.some(o2 => o1.id === o2.id));
          this.previousSelectedRows = searchSelRows;
        }
        if (selectedRows.length > 0 && this.depSelectedRowsData && this.depSelectedRowsData.length > 0) {
          searchSelRows = [...searchSelRows, ...this.depSelectedRowsData];
        } else {
          this.isSourceRowSelected = false;
          this.previousSelectedRows = [];
          this.depSelectedRowsData = [];
          this.selectedRowsIds = [];
        }
        this.selectedsourceorgrows = searchSelRows;
        this.selectedsourcedata = searchSelRows;
        const selectedEvent = new CustomEvent('selectedsourcegridrows', {
          detail: searchSelRows
        });
        this.dispatchEvent(selectedEvent);
      }
    };
    this.formatTargetData = rows => {
      let tempRowsList = [];
      if (rows.length > 0) {
        for (let index = 0; index < rows.length; index++) {
          const {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          } = rows[index];
          const formattedRow = {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          };
          tempRowsList.push(formattedRow);
        }
      }
      return tempRowsList;
    };
    this.removeSearchUnSelectedRows = selectedRows => {
      const searchSelectedRows = this.searchSelectedRows;
      const selRows = searchSelectedRows.filter(o1 => selectedRows.some(o2 => o1.id === o2.id));
      this.searchSelectedRows = selRows;
    };
    this.getSearchSelectedRows = selectedRows => {
      if (selectedRows.length > 0) {
        for (let index = 0; index < selectedRows.length; index++) {
          const {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          } = selectedRows[index];
          const formattedRow = {
            componentType,
            configType,
            componentName,
            createdBy,
            createdOn,
            developerName,
            id,
            modifiedBy,
            modifiedOn,
            name,
            translationConfigurations
          };
          this.searchSelectedRows.push(formattedRow);
          this.removeDuplicateRows(this.searchSelectedRows);
        }
      } else {
        this.searchSelectedRows = selectedRows;
      }
    };
    this.removeDuplicateRows = data => {
      let copyOfData = data;
      let dupsCount = 0;
      copyOfData.sort(function (a, b) {
        let textA = a.id;
        let textB = b.id;
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      for (let i = 0; i < copyOfData.length - 1;) {
        if (copyOfData[i].id == copyOfData[i + 1].id) {
          dupsCount++;
          copyOfData.splice(i, 1);
        } else {
          i++;
        }
      }
      return copyOfData;
    };
    this.handleTargetDataTableSearch = event => {
      let searchValue = event === null ? filterValue : event.currentTarget.value;
      console.log('search value is :: ', searchValue);
      let tempConfigurations = this.selectedsourcedata;
      if (searchValue.length > 2) {
        searchValue = searchValue.toLowerCase();
        tempConfigurations = tempConfigurations.filter(item => item.name.toLowerCase().includes(searchValue) || item.developerName.toLowerCase().includes(searchValue) || item.configType.toLowerCase().includes(searchValue) || item.componentType.toLowerCase().includes(searchValue));
      } else if (searchValue.length === 0) {
        tempConfigurations = this.selectedsourcedata;
        this.searchConfigName = '';
        this.searchDeveloperName = '';
        this.searchCompType = '';
      }
      this.selectedsourceorgrows = tempConfigurations;
    };
    this.handleTargetTreeGridSearch = (event, filterValue) => {
      let searchValue = event === null ? filterValue : event.currentTarget.value;
      if (searchValue !== null) {
        searchValue = searchValue.toLowerCase();
      }
      let tempConfigurations = this.originalSelectedRows;
      let firstLevelFilteredData;
      if (searchValue !== '') {
        if (tempConfigurations !== undefined) {
          tempConfigurations = this.getFilteredData(this.selectedsourceorgrows, searchValue, 'parent');
          if (tempConfigurations !== undefined && tempConfigurations.length > 0) {
            this.expandedRow = [tempConfigurations[0].name];
          }
          if (tempConfigurations !== undefined && tempConfigurations.length === 0) {
            this.selectedsourceorgrows.filter(element => {
              firstLevelFilteredData = this.getFilteredData(element._children, searchValue, 'level1');
              if (firstLevelFilteredData !== undefined && firstLevelFilteredData.length > 0) {
                tempConfigurations = firstLevelFilteredData;
                this.expandedRow = [tempConfigurations[0].name];
              }
            });
          }
          if (firstLevelFilteredData !== undefined && firstLevelFilteredData.length === 0) {
            this.selectedsourceorgrows.filter(element => {
              element._children.filter(item => {
                const secondLevelFilteredData = this.getFilteredData(item._children, searchValue, 'level2');
                if (secondLevelFilteredData !== undefined && secondLevelFilteredData.length > 0) {
                  tempConfigurations = secondLevelFilteredData;
                }
              });
            });
          }
          this.selectedsourceorgrows = tempConfigurations;
        }
      } else {
        this.selectedsourceorgrows = this.originalSelectedRows;
        this.expandedRow = [this.originalSelectedRows[0].name];
      }
    };
    this.getFilteredData = (originalConfig, searchValue, level) => {
      let filteredData;
      if (originalConfig !== undefined) {
        filteredData = originalConfig.filter(item => level === 'parent' || level === 'level1' ? item.name.toLowerCase().includes(searchValue) : this.getSecondLevelFilteredData(item, searchValue));
      }
      return filteredData;
    };
    this.getSecondLevelFilteredData = (secondLevelData, searchValue) => {
      let secondLevelFilteredData = {};
      if (secondLevelData !== undefined) {
        secondLevelFilteredData = secondLevelData.name.includes(searchValue) || secondLevelData.developerName.toLowerCase().includes(searchValue) || secondLevelData.modifiedBy.toLowerCase().includes(searchValue);
      }
      return secondLevelFilteredData;
    };
    this.handleFilterModal = () => {
      if (this.isFilterModalOpen) {
        this.closeFilterModalPopup();
        this.disableFilterIcon();
      } else {
        this.isFilterModalOpen = true;
        const tempData = this.originalconfigurations;
        const tempCompType = [];
        const tempModifiedBy = [];
        const tempTags = [];
        for (let index = 0; index < tempData.length; index++) {
          const {
            componentName,
            modifiedBy,
            tags
          } = tempData[index];
          tempCompType.push(componentName);
          tempModifiedBy.push(modifiedBy);
          tempTags.push(tags);
        }
        this.uniqueCompType = [...new Set(tempCompType)];
        this.uniqueModifiedBy = [...new Set(tempModifiedBy)];
        this.uniqueTags = [...new Set(tempTags.flat())];
        this.enableFilterIcon();
      }
    };
    this.closeFilterModalPopup = () => {
      this.isFilterModalOpen = false;
      this.disableFilterIcon();
    };
    this.enableFilterIcon = () => {
      if (this.template.querySelector('div[data-my-id="advFilterBtnDiv"]')) {
        this.template.querySelector('div[data-my-id="advFilterBtnDiv"]').classList.add('filter-btn_bgcolor');
      }
    };
    this.clearFilterValues = () => {
      this.searchConfigName = '';
      this.searchDeveloperName = '';
      this.searchCompType = 'Select';
      this.searchModifiedBy = 'Select';
      this.searchTags = 'Select';
      this.selectedModifiedValues = [];
      this.selectedOptionTypeValues = [];
      this.selectedTagsValues = [];
      this.disableFilterIcon();
    };
    this.disableFilterIcon = () => {
      if (this.template.querySelector('div[data-my-id="advFilterBtnDiv"]')) {
        this.template.querySelector('div[data-my-id="advFilterBtnDiv"]').classList.remove('filter-btn_bgcolor');
      }
      const filterSearchEvent = new CustomEvent('filterconfigurations', {
        detail: []
      });
      this.dispatchEvent(filterSearchEvent);
    };
    this.applySearchFilterOnTargetDataTable = () => {
      const searchInput = this.template.querySelector('input[data-my-id="targetTreeGridSearchInput"]');
      const configurationName = this.template.querySelector('input[data-my-id="targetConfigurationName"]').value;
      const developerName = this.template.querySelector('input[data-my-id="targetDeveloperName"]').value;
      const compType = this.template.querySelector('input[data-my-id="targetCompType"]').value;
      const compSubType = this.template.querySelector('input[data-my-id="targetCompSubType"]').value;
      const filterValues = [configurationName, developerName, compType, compSubType];
      const searchfFilterValue = [];
      for (let index = 0; index < filterValues.length; index++) {
        if (filterValues[index] !== '') {
          searchfFilterValue.push(filterValues[index]);
        }
      }
      searchInput.value = searchfFilterValue.join(', ');
      this.selectedsourceorgrows = this.selectedsourceorgrows.filter(item => item.name.toLowerCase().includes(configurationName.toLowerCase()) && item.developerName.toLowerCase().includes(developerName.toLowerCase()) && item.configType.toLowerCase().includes(compType.toLowerCase()) && item.componentType.toLowerCase().includes(compSubType.toLowerCase()));
      this.isFilterModalOpen = false;
      this.searchConfigName = configurationName;
      this.searchDeveloperName = developerName;
      this.searchCompType = compType;
      this.searchSubType = compSubType;
    };
    this.handleSearch = event => {
      const searchEvent = new CustomEvent('sourcedatatablesearch', {
        detail: event.currentTarget.value
      });
      this.dispatchEvent(searchEvent);
    };
    this.applySearchFilterData = () => {
      const configurationType = this.template.querySelector('input[data-my-id="targetConfigurationType"]') !== undefined ? this.template.querySelector('input[data-my-id="targetConfigurationType"]').value : '';
      const modifiedBy = this.template.querySelector('input[data-my-id="targetModifiedBy"]') !== undefined ? this.template.querySelector('input[data-my-id="targetModifiedBy"]').value : '';
      /* const fromDate = this.template.querySelector('lightning-input[data-my-id="targetFromDate"]') !== undefined ? this.template.querySelector('lightning-input[data-my-id="targetFromDate"]') : "";
      const toDate = this.template.querySelector('lightning-input[data-my-id="targetToDate"]') !== undefined ? this.template.querySelector('lightning-input[data-my-id="targetToDate"]') : ""; */
      const searchInput = this.template.querySelector('input[data-my-id="targetTreeGridSearchInput"]');
      if (configurationType !== '' && modifiedBy === '') {
        this.handleTargetTreeGridSearch(null, configurationType);
        searchInput.value = `${configurationType}`;
      } else if (configurationType === '' && modifiedBy !== '') {
        this.handleTargetTreeGridSearch(null, modifiedBy);
        searchInput.value = `${modifiedBy}`;
      } else if (configurationType !== '' && modifiedBy !== '') {
        this.handleFilterData(configurationType, modifiedBy);
        searchInput.value = `${configurationType},${modifiedBy}`;
      }
      this.isFilterModalOpen = false;
    };
    this.handleFilterData = (configType, modifiedBy) => {
      let tempConfigurations = this.originalSelectedRows;
      let filteredData = [];
      tempConfigurations.filter(element => {
        if (element._children !== undefined) {
          element._children.filter(item => {
            if (item._children !== undefined) {
              item._children.filter(secondLevelChild => {
                if (secondLevelChild.name.toLowerCase().includes(configType) && secondLevelChild.modifiedBy.toLowerCase().includes(modifiedBy)) {
                  filteredData = item._children;
                }
              });
            }
          });
        }
      });
      this.selectedsourceorgrows = filteredData;
    };
    this.selectedOptionTypes = event => {
      const selOptionTypes = event.detail.selectedTypes;
      const selectedPicklistType = event.detail.selectedPicklist;
      if (selectedPicklistType === 'compType') {
        this.selectedOptionTypeValues = selOptionTypes;
      }
      if (selectedPicklistType === 'modifiedBy') {
        this.selectedModifiedValues = selOptionTypes;
      }
      if (selectedPicklistType === 'tags') {
        this.selectedTagsValues = selOptionTypes;
      }
      if (this.template.querySelector('my-filter-modal')) {
        this.template.querySelector('my-filter-modal').updatedSelectionTypes(selOptionTypes, selectedPicklistType);
      }
    };
    this.onApplyFilter = event => {
      const filterCriteria = event.detail;
      let tempConfigurations = [];
      let {
        configurationName,
        compType,
        modifiedBy,
        tags,
        fromDate,
        toDate
      } = filterCriteria;
      const formattedFromDate = fromDate ? formatDate(fromDate) : '';
      const formattedToDate = toDate ? formatDate(toDate) : '';
      let isDateFilterEmpty = false;
      if (formattedFromDate === '' && formattedToDate === '') {
        isDateFilterEmpty = true;
      }
      if (tags && tags.length === 1 && tags[0] === NONE_OPTION) {
        tags = [];
      }
      this.enableFilterIcon();
      const localeDateFormat = getDateLocaleFormat();
      const delimeter = getDelimiterFromLocaleDateFormat(localeDateFormat);
      let originalConfigurations = this.originalconfigurations;
      if (configurationName !== '' && compType.length === 0 && modifiedBy.length === 0 && tags.length === 0 && isDateFilterEmpty) {
        configurationName = configurationName.trim();
        tempConfigurations = originalConfigurations.filter(item => item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase()));
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length === 0 && tags.length === 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName));
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length > 0 && tags.length === 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => modifiedBy.includes(item.modifiedBy));
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length === 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length === 0 && tags.length === 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length === 0 && tags.length === 0 && !isDateFilterEmpty) {
        configurationName = configurationName.trim();
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length === 0 && tags.length === 0 && isDateFilterEmpty) {
        configurationName = configurationName.trim();
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName));
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length > 0 && tags.length === 0 && isDateFilterEmpty) {
        configurationName = configurationName.trim();
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && modifiedBy.includes(item.modifiedBy));
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length === 0 && tags.length > 0 && isDateFilterEmpty) {
        configurationName = configurationName.trim();
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length === 0 && tags.length === 0 && !isDateFilterEmpty) {
        configurationName = configurationName.trim();
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase()))(item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length === 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length > 0 && tags.length === 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => modifiedBy.includes(item.modifiedBy) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length > 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && modifiedBy.includes(item.modifiedBy));
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length > 0 && tags.length === 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy));
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length > 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length === 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length > 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length === 0 && tags.length === 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length === 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length > 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => modifiedBy.includes(item.modifiedBy) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length === 0 && tags.length === 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName));
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length > 0 && tags.length === 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && modifiedBy.includes(item.modifiedBy));
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length > 0 && tags.length === 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && modifiedBy.includes(item.modifiedBy) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length === 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length > 0 && tags.length === 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy));
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length === 0 && tags.length === 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length === 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length > 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName !== '' && compType.length > 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length === 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length > 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length > 0 && tags.length > 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && modifiedBy.includes(item.modifiedBy) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName !== '' && compType.length === 0 && modifiedBy.length > 0 && tags.length > 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && modifiedBy.includes(item.modifiedBy) && item.tags && item.tags.some(tagArr => tags.includes(tagArr)));
      } else if (configurationName !== '' && compType.length > 0 && modifiedBy.length > 0 && tags.length === 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => (item.name && item.name.toLowerCase().includes(configurationName.toLowerCase()) || item.developerName && item.developerName.toLowerCase().includes(configurationName.toLowerCase())) && compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length > 0 && modifiedBy.length > 0 && tags.length === 0 && !isDateFilterEmpty) {
        tempConfigurations = originalConfigurations.filter(item => compType.includes(item.componentName) && modifiedBy.includes(item.modifiedBy) && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) >= formattedFromDate && (item.modifiedOn && formatLocaleDate(item.modifiedOn.split(',')[0], localeDateFormat, delimeter)) <= formattedToDate);
      } else if (configurationName === '' && compType.length === 0 && modifiedBy.length === 0 && tags.length === 0 && isDateFilterEmpty) {
        tempConfigurations = originalConfigurations;
        this.issearchenabled = false;
        this.disableFilterIcon();
      }
      this.data = tempConfigurations;
      this.filteredConfigs = tempConfigurations;
      this.searchConfigName = configurationName;
      this.searchCompType = compType;
      this.searchModifiedBy = modifiedBy;
      this.searchTags = tags;
      this.searchFromDate = fromDate;
      this.searchToDate = toDate;
      const filterSearchEvent = new CustomEvent('filterconfigurations', {
        detail: tempConfigurations,
        bubbles: true,
        composed: true
      });
      this.dispatchEvent(filterSearchEvent);
      if (this.isFilterModalOpen) {
        this.isFilterModalOpen = false;
      }
    };
    this.clearSearchValue = () => {
      this.template.querySelector('input[data-my-id="sourceDataTableSearchInput"]').value = '';
      this.template.querySelector('button[data-my-id="searchClearButton"]').style.display = 'none';
      this.issearchenabled = false;
      let clearSearchEvent;
      const filteredConfigs = this.filteredConfigs;
      if (filteredConfigs && filteredConfigs.length === 0) {
        clearSearchEvent = new CustomEvent('filterconfigurations', {
          detail: [],
          bubbles: true,
          composed: true
        });
      } else {
        clearSearchEvent = new CustomEvent('sourcedatatablesearch', {
          detail: []
        });
      }
      this.dispatchEvent(clearSearchEvent);
    };
    this.enableDisableClearButton = event => {
      if (event.currentTarget.value && event.currentTarget.value.length > 0) {
        this.searchValueExists = true;
        this.template.querySelector('button[data-my-id="searchClearButton"]').style.display = 'block';
      } else {
        this.searchValueExists = false;
        this.template.querySelector('button[data-my-id="searchClearButton"]').style.display = 'none';
      }
    };
    this.searchEnabled = isSearchSel => {
      this.issearchenabled = isSearchSel;
    };
    this.addEventListener('selecteddependenciesrows', this.selectedDependenciesRows.bind(this));
    this.addEventListener('selecteddeprows', this.selectedDepRowIds.bind(this));
  }
  sortBy(field, reverse, primer) {
    const key = primer ? function (x) {
      return primer(x[field]);
    } : function (x) {
      return x[field];
    };
    return function (a, b) {
      a = key(a);
      b = key(b);
      return reverse * ((a > b) - (b > a));
    };
  }
  onHandleSort(event) {
    const {
      fieldName: sortedBy,
      sortDirection
    } = event.detail;
    const cloneData = [...this.data];
    if (sortedBy === MODIFIED_ON) {
      this.data = sortByDate(JSON.parse(JSON.stringify(cloneData)), MODIFIED_ON, sortDirection === 'asc' ? true : false);
    } else {
      cloneData.sort(this.sortBy(sortedBy, sortDirection === 'asc' ? 1 : -1));
      this.data = cloneData;
    }
    this.sortDirection = sortDirection;
    this.sortedBy = sortedBy;
  }

  // hide the menu action items
  renderedCallback() {
    if (!this.hasRendered) {
      const style = document.createElement('style');
      /* style.innerText =
          "my-source-tree-grid lightning-datatable .slds-th__action-button {display: none;}"; */
      /*  this.template
          .querySelector("lightning-datatable")
          .appendChild(style); */
      this.hasRendered = true;
    }
    this.enableDisableFilterTextClearButton();
    if (this.isexportbtndisabled) {
      this.template.querySelector('.slds-source_treegrid').classList.add("table-top_align");
      this.template.querySelector('div[data-my-id="sourceDataTableDiv"]').classList.add("sourcegrid-upload__align");
    } else {
      this.template.querySelector('.slds-source_treegrid').classList.remove("table-top_align");
      this.template.querySelector('div[data-my-id="sourceDataTableDiv"]').classList.remove("sourcegrid-upload__align");
    }
    const filterModalRef = this.template.querySelector('my-filter-modal');
    if (filterModalRef) {
      filterModalRef.showModifiedByUsers(this.uniqueModifiedBy);
      filterModalRef.compTypeOptions(this.uniqueCompType);
      filterModalRef.showTags(this.uniqueTags);
      let selModifiedValues = [];
      let selOptionTypeValues = [];
      let selTagsValues = [];
      if (this.selectedModifiedValues && this.selectedModifiedValues.length > 0) {
        selModifiedValues = this.getSelNames(JSON.parse(this.selectedModifiedValues));
      }
      if (this.searchModifiedBy !== null && this.searchModifiedBy.length > 0) {
        filterModalRef.updateSelModifiedByValue(this.uniqueModifiedBy, this.searchModifiedBy, selModifiedValues);
        filterModalRef.updatedSelectionTypes(this.selectedModifiedValues, 'modifiedBy');
      }
      if (this.selectedOptionTypeValues && this.selectedOptionTypeValues.length > 0) {
        selOptionTypeValues = this.getSelNames(JSON.parse(this.selectedOptionTypeValues));
      }
      if (this.searchCompType !== null && this.searchCompType.length > 0) {
        filterModalRef.updateSelTypeValue(this.uniqueCompType, this.searchCompType, selOptionTypeValues);
        filterModalRef.updatedSelectionTypes(this.selectedOptionTypeValues, 'compType');
      }
      if (this.selectedTagsValues && this.selectedTagsValues.length > 0) {
        selTagsValues = this.getSelNames(JSON.parse(this.selectedTagsValues));
      }
      if (this.searchTags !== null && this.searchTags.length > 0) {
        filterModalRef.updateSelTagsValue(this.uniqueTags, this.searchTags, selTagsValues);
        filterModalRef.updatedSelectionTypes(this.selectedTagsValues, 'tags');
      }
    }
    if (this.template.querySelector('button[data-my-id="searchClearButton"]') && !this.searchValueExists) {
      this.template.querySelector('button[data-my-id="searchClearButton"]').style.display = 'none';
    }
  }
  get targetTreeGridEnabled() {
    return this.isSourceRowSelected && this.istargetorgloggedin;
  }
}
_registerDecorators(SourceDataTable, {
  publicProps: {
    data: {
      config: 0
    },
    selectedsourceorgrows: {
      config: 0
    },
    selectedsourcedata: {
      config: 0
    },
    istargetorgloggedin: {
      config: 0
    },
    issearchenabled: {
      config: 0
    },
    targettreegriddata: {
      config: 0
    },
    preselectedrowsids: {
      config: 0
    },
    searchvalue: {
      config: 0
    },
    originalconfigurations: {
      config: 0
    },
    searchConfigName: {
      config: 0
    },
    searchDeveloperName: {
      config: 0
    },
    searchCompType: {
      config: 0
    },
    searchModifiedBy: {
      config: 0
    },
    searchTags: {
      config: 0
    },
    searchSubType: {
      config: 0
    },
    searchFromDate: {
      config: 0
    },
    searchToDate: {
      config: 0
    },
    isexportbtndisabled: {
      config: 0
    },
    updateSelectedDepRows: {
      config: 0
    },
    updateDepRowsAfterRemoveTargetRecord: {
      config: 0
    },
    updatePreviousSelectedRows: {
      config: 0
    },
    disableFilterIcon: {
      config: 0
    },
    searchEnabled: {
      config: 0
    }
  },
  fields: ["columns", "record", "gridLoadingState", "isFilterModalOpen", "originalSelectedRows", "selectedRows", "searchSelectedRows", "previousSelectedRows", "isSourceRowSelected", "defaultSortDirection", "sortDirection", "sortedBy", "selectedRowsIds", "depSelectedRowsData", "uniqueCompType", "uniqueModifiedBy", "uniqueTags", "selectedOptionTypeValues", "selectedModifiedValues", "selectedTagsValues", "searchValueExists", "searchResultRows", "filteredConfigs", "getSelNames", "enableDisableFilterTextClearButton", "handleExportConfigurations", "closeExportConfModal", "selectedDependenciesRows", "formattedSelectedSourceOrgRows", "selectedDepRowIds", "getSelectedName", "formatTargetData", "removeSearchUnSelectedRows", "getSearchSelectedRows", "removeDuplicateRows", "handleTargetDataTableSearch", "handleTargetTreeGridSearch", "getFilteredData", "getSecondLevelFilteredData", "handleFilterModal", "closeFilterModalPopup", "enableFilterIcon", "clearFilterValues", "applySearchFilterOnTargetDataTable", "handleSearch", "applySearchFilterData", "handleFilterData", "selectedOptionTypes", "onApplyFilter", "clearSearchValue", "enableDisableClearButton"]
});
export default _registerComponent(SourceDataTable, {
  tmpl: _tmpl
});